function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18499",
    transform: "translate(-504 -747)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1122",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(504 747)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "document (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59584",
    d: "M78.475 4.981 73.955.705A2.568 2.568 0 0 0 72.183 0h-8.605A2.581 2.581 0 0 0 61 2.578v18.844A2.581 2.581 0 0 0 63.578 24H76.7a2.581 2.581 0 0 0 2.578-2.578V6.854a2.589 2.589 0 0 0-.806-1.873zm-1.366.644h-3.5a.235.235 0 0 1-.234-.234v-3.3zM76.7 22.594H63.578a1.173 1.173 0 0 1-1.172-1.172V2.578a1.173 1.173 0 0 1 1.172-1.172h8.391v3.985a1.642 1.642 0 0 0 1.641 1.641h4.266v14.39a1.173 1.173 0 0 1-1.176 1.172z",
    style: {
      fill: "#55a77b"
    },
    transform: "translate(458 759)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59585",
    d: "M139.016 200H128.7a.7.7 0 0 0 0 1.406h10.313a.7.7 0 0 0 0-1.406z",
    transform: "translate(394.141 568.375)",
    style: {
      fill: "#55a77b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59586",
    d: "M139.016 280H128.7a.7.7 0 0 0 0 1.406h10.313a.7.7 0 0 0 0-1.406z",
    transform: "translate(394.141 492.125)",
    style: {
      fill: "#55a77b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59587",
    d: "M132.112 360H128.7a.7.7 0 0 0 0 1.406h3.409a.7.7 0 0 0 0-1.406z",
    transform: "translate(394.141 415.875)",
    style: {
      fill: "#55a77b"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadfile);
export default __webpack_public_path__ + "static/media/uploadfile.a125aaeb957f5d813490e593527c527d.svg";
export { ForwardRef as ReactComponent };